class DataQueue {
    constructor() {
      this.q = [];
    }
  
    push(arr) {
      if (!arr || arr.length === 0) return;
      this.q.push(...arr);
    }
  
    popN(n) {
      if (this.q.length === 0 || n < 0) return [];
      return this.q.splice(0, n);
    }
    clear() {
        this.q = [];
    }

  
    size() {
      return this.q.length;
    }
}
  
export default DataQueue;